// Public Marketplace pages.
//
// Everything here is an enhancement over a page that already works. With
// JavaScript off: the first slide still renders, the browse form is a plain GET
// form with a Search button, the filters are plain selects, the subject chips
// and pager are links, and the sign-up prompts fall back to the auth page. What
// this file adds is scaling the fixed-size slides, paging the viewer without a
// reload, submitting the filters on change, and the controls that are genuinely
// interactive – save, copy link, take a copy, report, sign in.
(function () {
    'use strict';

    var SLIDE_W = 960;
    var SLIDE_H = 540;

    // ── Slide scaling ─────────────────────────────────────
    // Slides are authored at a fixed 960x540 and positioned absolutely, so they
    // have no layout height of their own. The SPA solves this in
    // scalePresPreviews, but that lives inside the app's IIFE and is not
    // reachable from here.
    function scaleAll() {
        var nodes = document.querySelectorAll('.slide-scale');
        for (var i = 0; i < nodes.length; i++) {
            var el = nodes[i];
            var box = el.parentElement;
            if (!box) continue;
            var w = box.clientWidth;
            if (!w) continue;
            var scale = w / SLIDE_W;
            el.style.transform = 'scale(' + scale + ')';
            box.style.height = (scale * SLIDE_H) + 'px';
        }
    }

    // ── Slide auto-fit ────────────────────────────────────
    // A slide whose content is taller than 540px is clipped unless it is
    // shrunk, which the editor and the exports both do. Without the same pass
    // here a listing showed the bottom of a busy slide cut off, on the one page
    // a visitor judges the deck by.
    // Keep in sync with autoFitSlides/fitBox in public/js/slideRenderer.js.
    function fitBox(box) {
        for (var i = 0; i < 4; i++) {
            if (!box.clientHeight) return; // hidden – nothing to measure
            if (box.scrollHeight - box.clientHeight <= 2) return;
            var prev = parseFloat(box.dataset.fitZoom || '1');
            var next = Math.max(0.6, prev * box.clientHeight / box.scrollHeight);
            if (next >= prev) return;
            box.dataset.fitZoom = String(next);
            for (var c = 0; c < box.children.length; c++) box.children[c].style.zoom = next;
        }
    }

    function fitAll() {
        var slides = document.querySelectorAll('.slide-scale .slide');
        for (var i = 0; i < slides.length; i++) {
            var slide = slides[i];
            if (slide.hasAttribute('data-no-autofit')) {
                var slots = slide.querySelectorAll('[data-slot-fit="shrink"]');
                for (var s = 0; s < slots.length; s++) fitBox(slots[s]);
                continue;
            }
            fitBox(slide);
            var cols = slide.querySelectorAll('.slide__content');
            for (var k = 0; k < cols.length; k++) fitBox(cols[k]);
        }
    }

    // Debounced: a drag-resize fires continuously and each pass touches every
    // slide on the page.
    var pending = null;
    function onResize() {
        if (pending) cancelAnimationFrame(pending);
        pending = requestAnimationFrame(function () {
            pending = null;
            scaleAll();
        });
    }

    // ── Slide viewer ──────────────────────────────────────
    function initViewer() {
        var viewer = document.querySelector('.mp-viewer');
        if (!viewer) return;
        var panels = viewer.querySelectorAll('.mp-panel');
        var total = panels.length;
        if (!total) return;
        var at = viewer.querySelector('.mp-viewer-at');
        var steps = viewer.querySelectorAll('.mp-step');
        var index = 0;

        function render() {
            for (var i = 0; i < panels.length; i++) {
                var on = i === index;
                panels[i].hidden = !on;
                panels[i].classList.toggle('active', on);
            }
            if (at) at.textContent = 'Slide ' + (index + 1) + ' of ' + total;
            for (var s = 0; s < steps.length; s++) {
                var d = parseInt(steps[s].getAttribute('data-step'), 10);
                steps[s].disabled = d < 0 ? index === 0 : index === total - 1;
            }
            // A panel revealed from hidden has never been measured, so it needs
            // scaling now rather than only on the next resize – and fitting,
            // for the same reason.
            scaleAll();
            fitAll();
        }

        viewer.addEventListener('click', function (e) {
            var btn = e.target.closest('.mp-step');
            if (!btn || btn.disabled) return;
            var next = index + parseInt(btn.getAttribute('data-step'), 10);
            if (next < 0 || next >= total) return;
            index = next;
            render();
        });

        // Arrow keys, but only once the viewer has been interacted with – the
        // page scrolls with the same keys and hijacking them on load is rude.
        viewer.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
            var next = index + (e.key === 'ArrowLeft' ? -1 : 1);
            if (next < 0 || next >= total) return;
            e.preventDefault();
            index = next;
            render();
        });

        render();
    }

    // ── Browse controls ───────────────────────────────────
    // The form works on its own; this only removes the step of pressing Search
    // after changing a dropdown, and strips empty fields so a plain browse stays
    // at /marketplace rather than /marketplace?q=&level=&board=&sort=recent.
    function initFilters() {
        var form = document.querySelector('.mp-filter-form');
        if (!form) return;

        form.addEventListener('submit', function () {
            var fields = form.querySelectorAll('input[name], select[name]');
            for (var i = 0; i < fields.length; i++) {
                // Disabled fields are not submitted, which is the one way to
                // drop a field from a GET form without rebuilding the URL.
                if (!fields[i].value) fields[i].disabled = true;
            }
        });

        var selects = form.querySelectorAll('select');
        for (var s = 0; s < selects.length; s++) {
            selects[s].addEventListener('change', function () {
                if (form.requestSubmit) form.requestSubmit();
                else form.submit();
            });
        }
        // The Search button is only needed when a change cannot submit for
        // itself, which is the no-JavaScript case this branch has ruled out.
        var go = form.querySelector('.mp-filter-go');
        if (go) go.hidden = true;
    }

    // ── Save for later ────────────────────────────────────
    // Optimistic: every control bound to the listing flips first, and only a
    // failed request puts them back. A save is trivially reversible, so waiting
    // on the network to show it costs more than being briefly wrong.
    function paintSaved(id, saved) {
        var nodes = document.querySelectorAll('[data-save="' + id.replace(/"/g, '\\"') + '"]');
        for (var i = 0; i < nodes.length; i++) {
            var el = nodes[i];
            el.setAttribute('aria-pressed', String(saved));
            el.classList.toggle('saved', saved);
            var label = saved ? 'Remove from saved' : 'Save for later';
            el.setAttribute('title', label);
            // The listing page's button is a worded one; the card's is an icon
            // and carries its wording in the accessible name instead.
            if (el.classList.contains('mp-save')) el.textContent = saved ? 'Saved' : 'Save';
            else el.setAttribute('aria-label', label);
        }
    }

    function initSave() {
        document.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-save]');
            if (!btn) return;
            var id = btn.getAttribute('data-save');
            var next = btn.getAttribute('aria-pressed') !== 'true';
            paintSaved(id, next);
            fetch('/api/resources/' + encodeURIComponent(id) + '/save', {
                method: next ? 'PUT' : 'DELETE',
                credentials: 'same-origin',
            }).then(function (res) {
                // A session that expired while the page was open lands here.
                if (res.status === 401) { window.location.reload(); return; }
                if (!res.ok) throw new Error('save failed');
            }).catch(function () {
                paintSaved(id, !next);
            });
        });
    }

    // ── I taught this ─────────────────────────────────────
    // The catalogue's second signal. Unlike a save, this is a public claim
    // other teachers will act on, so it is NOT optimistic: the count only moves
    // once the server has agreed, and the server is the thing that knows
    // whether this person actually took the lesson.
    function initEndorse() {
        document.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-endorse]');
            if (!btn || btn.disabled) return;
            var id = btn.getAttribute('data-endorse');
            var next = btn.getAttribute('aria-pressed') !== 'true';
            // Only the label span, never the button: the tick beside it is an
            // element, and writing textContent would delete it.
            var labelEl = btn.querySelector('.mp-endorse-label') || btn;
            var label = labelEl.textContent;

            btn.disabled = true;
            fetch('/api/resources/' + encodeURIComponent(id) + '/endorse', {
                method: next ? 'PUT' : 'DELETE',
                credentials: 'same-origin',
            }).then(function (res) {
                // A session that expired while the page was open lands here.
                if (res.status === 401) { window.location.reload(); return null; }
                return res.json().then(function (data) {
                    if (!res.ok) throw new Error(data.error || 'Could not save that');
                    return data;
                });
            }).then(function (data) {
                if (!data) return;
                btn.setAttribute('aria-pressed', String(data.endorsed));
                btn.classList.toggle('on', data.endorsed);
                labelEl.textContent = data.endorsed ? 'You taught this' : 'I taught this';
                // The count lives in the header badge, which is rendered even
                // at zero (hidden) so that the first endorsement has something
                // to fill in. Hide it again if this was an un-endorse that took
                // the lesson back to nobody.
                var count = document.querySelector('[data-endorse-count="' + id.replace(/"/g, '\\"') + '"]');
                if (count) {
                    count.textContent = !data.endorseCount ? ''
                        : data.endorseCount === 1
                            ? '1 teacher taught this'
                            : data.endorseCount + ' teachers taught this';
                    var badge = count.closest('.mp-listing-taught');
                    if (badge) badge.hidden = !data.endorseCount;
                }
            }).catch(function (err) {
                labelEl.textContent = label;
                var errEl = document.getElementById('mp-error');
                if (errEl) {
                    errEl.textContent = err.message || 'Something went wrong. Please try again.';
                    errEl.hidden = false;
                }
            }).finally(function () {
                btn.disabled = false;
            });
        });
    }

    // ── Copy link ─────────────────────────────────────────
    // Listings have URLs so a teacher who finds something can send it to the
    // person next to them; this is the control that makes that one click.
    function initCopy() {
        document.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-copy]');
            if (!btn) return;
            var url = btn.getAttribute('data-copy');
            var restore = function () { setTimeout(function () { btn.textContent = 'Copy link'; }, 1800); };
            if (navigator.clipboard) {
                navigator.clipboard.writeText(url).then(function () {
                    btn.textContent = 'Copied';
                    restore();
                }).catch(function () {
                    window.prompt('Copy this link', url);
                });
            } else {
                window.prompt('Copy this link', url);
            }
        });
    }

    // ── Take a copy ───────────────────────────────────────
    // Only rendered for signed-in visitors; a signed-out page has a plain link
    // to sign-up in its place.
    function initUseButton() {
        var btn = document.querySelector('[data-use]');
        if (!btn) return;
        var errEl = document.getElementById('mp-error');
        btn.addEventListener('click', function () {
            var id = btn.getAttribute('data-use');
            btn.disabled = true;
            btn.textContent = 'Adding to your library…';
            if (errEl) errEl.hidden = true;
            fetch('/api/resources/' + encodeURIComponent(id) + '/clone', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
            }).then(function (res) {
                // A session that expired while the page was open lands here.
                if (res.status === 401) { window.location.href = '/'; return null; }
                return res.json().then(function (data) {
                    if (!res.ok) throw new Error(data.error || 'Could not add this to your library');
                    return data;
                });
            }).then(function (data) {
                if (!data) return;
                // Straight into the editor, the same place the in-app flow ends.
                window.location.href = '/p/' + data.presentationId;
            }).catch(function (err) {
                if (errEl) {
                    errEl.textContent = err.message || 'Something went wrong. Please try again.';
                    errEl.hidden = false;
                }
                btn.disabled = false;
                btn.textContent = 'Use this lesson';
            });
        });
    }

    // ── Take a whole series ───────────────────────────────
    // The one control on a series page that does anything. Bound directly
    // rather than delegated, the same as initUseButton: there is exactly one of
    // these per page. Everything else on that page is a lesson card, whose save
    // and sign-up controls the delegated handlers above already serve.
    // Taking a template is a copy into the visitor's own library, so the button
    // ends up pointing at the library rather than reloading a page whose state
    // has not changed.
    function initTemplateTake() {
        var btn = document.querySelector('[data-take-template]');
        if (!btn) return;
        var msg = document.getElementById('mp-take-msg');
        var id = btn.getAttribute('data-take-template');
        btn.addEventListener('click', function () {
            btn.disabled = true;
            btn.textContent = 'Adding…';
            if (msg) msg.hidden = true;
            fetch('/api/slide-templates/from-listing/' + encodeURIComponent(id), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
            }).then(function (res) {
                if (res.status === 401) { window.location.href = '/'; return null; }
                return res.json().then(function (data) {
                    if (!res.ok) throw new Error(data.error || 'Could not add this to your library');
                    return data;
                });
            }).then(function (data) {
                if (!data) return;
                btn.disabled = false;
                btn.textContent = 'Open your library →';
                btn.removeAttribute('data-take-template');
                btn.addEventListener('click', function () { window.location.href = '/'; });
                if (msg) {
                    msg.textContent = 'Added to your templates. It will be offered on your next deck.';
                    msg.hidden = false;
                }
            }).catch(function (err) {
                btn.disabled = false;
                btn.textContent = 'Add to my templates';
                if (msg) {
                    msg.textContent = err.message || 'Could not add this to your library.';
                    msg.hidden = false;
                }
            });
        });
    }

    function initSeriesTake() {
        var btn = document.querySelector('[data-take-series]');
        if (!btn) return;
        var errEl = document.getElementById('mp-error');
        var id = btn.getAttribute('data-take-series');
        var count = parseInt(btn.getAttribute('data-count'), 10) || 0;
        btn.addEventListener('click', function () {
            btn.disabled = true;
            btn.textContent = 'Adding ' + count + ' lessons…';
            if (errEl) errEl.hidden = true;
            fetch('/api/series/' + encodeURIComponent(id) + '/clone', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
            }).then(function (res) {
                if (res.status === 401) { window.location.href = '/'; return null; }
                return res.json().then(function (data) {
                    if (!res.ok) throw new Error(data.error || 'Could not add these to your library');
                    return data;
                });
            }).then(function (data) {
                if (!data) return;
                var got = (data.taken || []).length;
                var missed = (data.skipped || []).length;
                // Nothing is allowed to go missing quietly. A partial take says
                // so and hands over a way on, rather than navigating away from
                // the news that some of it did not arrive.
                if (missed) {
                    if (errEl) {
                        errEl.textContent = got + ' of ' + (got + missed)
                            + ' lessons added to your library. The rest could not be copied.';
                        errEl.hidden = false;
                    }
                    btn.disabled = false;
                    btn.textContent = 'Open your library →';
                    btn.onclick = function () { window.location.href = '/'; };
                    return;
                }
                // One lesson behaves exactly like the single-lesson button.
                // More than one goes to the library instead, because dropping
                // someone into deck 1 of 8 hides the other seven.
                window.location.href = got === 1 ? '/p/' + data.taken[0].presentationId : '/';
            }).catch(function (err) {
                if (errEl) {
                    errEl.textContent = err.message || 'Something went wrong. Please try again.';
                    errEl.hidden = false;
                }
                btn.disabled = false;
                btn.textContent = 'Take all ' + count + ' lessons';
            });
        });
    }

    // ── Report a listing ──────────────────────────────────
    // Only rendered for signed-in visitors: the endpoint is one report per
    // person per listing, which needs an account to mean anything. A signed-out
    // reader gets a prefilled mailto in the same spot instead.
    function initReport() {
        var modal = document.getElementById('mp-report-modal');
        var open = document.getElementById('mp-report-open');
        if (!modal || !open) return;
        var send = document.getElementById('mp-report-send');
        var errEl = document.getElementById('mp-report-error');
        var lastFocus = null;

        function close() {
            modal.hidden = true;
            document.removeEventListener('keydown', onKey);
            if (lastFocus) lastFocus.focus();
        }
        function onKey(e) { if (e.key === 'Escape') close(); }

        open.addEventListener('click', function () {
            lastFocus = document.activeElement;
            var checked = modal.querySelector('input[name="mp-reason"]:checked');
            if (checked) checked.checked = false;
            document.getElementById('mp-report-note').value = '';
            if (errEl) errEl.hidden = true;
            modal.hidden = false;
            document.addEventListener('keydown', onKey);
            modal.querySelector('input[name="mp-reason"]').focus();
        });

        modal.addEventListener('click', function (e) {
            if (e.target.closest('[data-mprep-close]')) close();
        });

        send.addEventListener('click', function () {
            var picked = modal.querySelector('input[name="mp-reason"]:checked');
            if (!picked) {
                if (errEl) { errEl.textContent = 'Pick a reason so we know what to look for.'; errEl.hidden = false; }
                return;
            }
            send.disabled = true;
            send.textContent = 'Sending…';
            if (errEl) errEl.hidden = true;
            fetch('/api/resources/' + encodeURIComponent(send.getAttribute('data-resource')) + '/report', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({
                    reason: picked.value,
                    note: document.getElementById('mp-report-note').value,
                }),
            }).then(function (res) {
                // A session that expired while the page was open lands here.
                if (res.status === 401) { window.location.href = '/'; return null; }
                return res.json().then(function (data) {
                    if (!res.ok) throw new Error(data.error || 'Could not send that report');
                    return data;
                });
            }).then(function (data) {
                if (!data) return;
                close();
                // The control is replaced rather than reset: there is one report
                // per person per listing, so offering the form again would only
                // produce the same outcome.
                var row = open.parentElement;
                row.textContent = 'Thanks – someone will look at this listing.';
                row.className = 'mp-report-row mp-report-done';
            }).catch(function (err) {
                if (errEl) { errEl.textContent = err.message || 'Something went wrong.'; errEl.hidden = false; }
            }).finally(function () {
                send.disabled = false;
                send.textContent = 'Send report';
            });
        });
    }

    // ── Sign in / create account, in place ────────────────
    // Every signed-out call to action opens this rather than navigating to the
    // landing page: the listing someone is reading is the reason they are
    // signing up, and sending them away loses it. On success the page reloads
    // and renders unlocked, in the same spot.
    function initAuth() {
        var modal = document.getElementById('mp-auth-modal');
        if (!modal) return;
        var locked = modal.getAttribute('data-signup-locked') === '1';
        var errEl = document.getElementById('mp-auth-error');
        var forms = {
            register: document.getElementById('mp-register-form'),
            login: document.getElementById('mp-login-form'),
        };
        // The heading stays put, as it does on the landing page; only the line
        // under it reflects which tab you are on.
        var subs = {
            register: 'Create an account and this page unlocks where you left it.',
            login: 'Sign in and this page unlocks where you left it.',
        };
        var lastFocus = null;

        function setTab(which) {
            forms.register.hidden = which !== 'register';
            forms.login.hidden = which !== 'login';
            document.getElementById('mp-auth-sub').textContent = subs[which];
            var tabs = modal.querySelectorAll('.mp-auth-tab');
            for (var i = 0; i < tabs.length; i++) {
                var on = tabs[i].getAttribute('data-authtab') === which;
                tabs[i].classList.toggle('active', on);
                tabs[i].setAttribute('aria-selected', String(on));
            }
            if (errEl) errEl.hidden = true;
            var first = forms[which].querySelector('input');
            if (first) first.focus();
        }

        function open(which) {
            lastFocus = document.activeElement;
            modal.hidden = false;
            document.addEventListener('keydown', onKey);
            setTab(which);
        }
        function close() {
            modal.hidden = true;
            document.removeEventListener('keydown', onKey);
            if (lastFocus) lastFocus.focus();
        }
        function onKey(e) { if (e.key === 'Escape') close(); }

        // One delegated listener, so every CTA on the page – nav, hero, lock
        // overlays, card download pills – opens the right tab without each
        // needing to be wired individually.
        document.addEventListener('click', function (e) {
            var trigger = e.target.closest('[data-auth]');
            if (!trigger) return;
            e.preventDefault();
            open(trigger.getAttribute('data-auth') === 'login' ? 'login' : 'register');
        });

        modal.addEventListener('click', function (e) {
            if (e.target.closest('[data-mpauth-close]')) return close();
            var tab = e.target.closest('[data-authtab]');
            if (tab) setTab(tab.getAttribute('data-authtab'));
        });

        // The server questions an address one slip from a big provider's –
        // gmial for gmail – and says which it thinks was meant. That is put as
        // a choice, not shown as an error: it is a guess. "Yes" corrects the
        // field and stops there, so the account is made from an address they
        // have seen in the box; "No" has nothing left to look at and sends the
        // form. Keeping the address as typed is remembered here and sent back,
        // which is what tells the server it has already asked.
        var questionedEmail = '';
        var askEl = document.createElement('div');
        askEl.className = 'mp-inline-ask';
        askEl.setAttribute('role', 'group');
        askEl.setAttribute('aria-live', 'polite');
        askEl.hidden = true;
        if (errEl) errEl.insertAdjacentElement('afterend', askEl);

        function askAboutEmail(data) {
            var form = forms.register;
            function answer(label, cls, onPick) {
                var b = document.createElement('button');
                b.type = 'button';
                b.className = cls;
                b.textContent = label;
                b.addEventListener('click', function () { askEl.hidden = true; onPick(); });
                return b;
            }
            var line = document.createElement('p');
            var meant = document.createElement('strong');
            meant.textContent = data.suggestion;
            line.append('Did you mean ', meant, '?');
            var actions = document.createElement('div');
            actions.className = 'mp-inline-ask-actions';
            actions.append(
                answer('Yes, change it', 'mp-inline-ask-yes', function () {
                    form.querySelector('[name=email]').value = data.suggestion;
                    form.querySelector('.mp-auth-submit').focus();
                }),
                answer('No, it’s right', 'mp-inline-ask-no', function () {
                    questionedEmail = data.questioned;
                    form.requestSubmit();
                })
            );
            askEl.replaceChildren(line, actions);
            askEl.hidden = false;
            actions.firstChild.focus();
        }

        function submit(which, e) {
            e.preventDefault();
            var form = forms[which];
            var btn = form.querySelector('.mp-auth-submit');
            var label = btn.textContent;
            // Both forms are email and password now. Registering used to send a
            // first and last name too; the fields are gone from the dialog
            // because it interrupts someone mid-lesson and every extra field is
            // paid for in sign-ups. The name is collected in Settings, and the
            // publish dialog insists on one before a listing can go out
            // credited to nobody – which is the only place it matters.
            var body = {
                email: form.querySelector('[name=email]').value.trim(),
                password: form.querySelector('[name=password]').value,
            };
            if (locked) body.code = form.querySelector('[name=code]').value;
            if (which === 'register') body.emailChecked = questionedEmail;

            btn.disabled = true;
            btn.textContent = which === 'register' ? 'Creating…' : 'Signing in…';
            if (errEl) errEl.hidden = true;
            askEl.hidden = true;

            fetch('/api/auth/' + which, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify(body),
            }).then(function (res) {
                return res.json().then(function (data) {
                    if (data.questioned) { askAboutEmail(data); throw null; }
                    if (!res.ok) throw new Error(data.error || 'Something went wrong. Please try again.');
                    return data;
                });
            }).then(function () {
                // Reload rather than patch the DOM: the unlocked page is a
                // different response from the server, slides and all.
                window.location.reload();
            }).catch(function (err) {
                // null is the question above, which has drawn itself.
                if (err && errEl) { errEl.textContent = err.message; errEl.hidden = false; }
                btn.disabled = false;
                btn.textContent = label;
            });
        }

        forms.register.addEventListener('submit', function (e) { submit('register', e); });
        forms.login.addEventListener('submit', function (e) { submit('login', e); });
    }

    function init() {
        scaleAll();
        fitAll();
        initViewer();
        initFilters();
        initSave();
        initEndorse();
        initCopy();
        initUseButton();
        initSeriesTake();
        initTemplateTake();
        initReport();
        initAuth();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    // Fonts landing late change nothing about the scale, but images inside a
    // slide can shift its content before the first paint settles – and both
    // change what overflows, so fit again once they are in.
    window.addEventListener('load', function () { scaleAll(); fitAll(); });
    window.addEventListener('resize', onResize);
})();
